module.exports = "<!-- <div class=\"sidebar-header\"></div> -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/app-sidebar/app-sidebar-header/app-sidebar-header.component.html
// module id = ./src/app/shared/components/app-sidebar/app-sidebar-header/app-sidebar-header.component.html
// module chunks = main